import { ComponentPropsWithoutRef } from 'react';
import { Typography } from '../../../ui';

export function Em(props: ComponentPropsWithoutRef<'em'>) {
  const { children, ...rest } = props;

  return (
    <Typography as="em" variant="body-s" weight="medium" {...rest}>
      {children}
    </Typography>
  );
}
